import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { AccountCircle, Visibility, VisibilityOff } from "@mui/icons-material";
import PasswordRounded from "@mui/icons-material/PasswordRounded";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import {
  createIdentityAPIEndpoint,
  EndPoints,
} from "../../services/OverViewAPIs";
import useAuthContext from "../../context/AuthContext";
import Img from "../../assets/logo.png";

const InitialValues = {
  UserName: "",
  Password: "",
};
function Login() {
  const [showPassword, setShowPassword] = useState(false);
  const [values, setValues] = useState(InitialValues);
  const [formErrors, setFormErrors] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const navigate = useNavigate();
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const { login } = useAuthContext();
  const { enqueueSnackbar } = useSnackbar();
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    setFormErrors(validate(values));
    setIsSubmit(true);
  };

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };
  const validate = (formValues) => {
    const errors = {};
    if (!formValues.UserName) errors.UserName = "Please enter your username.";
    if (!formValues.Password) errors.Password = "Please enter your password.";
    return errors;
  };
  const resetForm = () => {
    setValues(InitialValues);
    setFormErrors({});
    setIsSubmit(false);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      const formData = new FormData();
      formData.append("UserName", values.UserName);
      formData.append("Password", values.Password);

      createIdentityAPIEndpoint(EndPoints.login)
        .post(formData)
        .then((res) => {
          login(res.data.token);
          navigate("/home");
          enqueueSnackbar("Login Success.", {
            variant: "success",
            style: { fontSize: "16px" },
          });
        })
        .catch((err) =>
          enqueueSnackbar(err.response.data.message || "Login Failed.", {
            variant: "error",
            style: { fontSize: "16px" },
          })
        );
      resetForm();
    }
  }, [formErrors, isSubmit, values, login, navigate, enqueueSnackbar]);

  return (
    <div className="login">
      <div className="container">
        <div className="logo">
          <img src={Img} alt="" />
        </div>
        <Grid
          container
          alignContent="center"
          justifyContent="center"
          className="form"
        >
          <Card elevation={6} className="card">
            <CardContent>
              <Typography
                variant="h4"
                component="div"
                sx={{ fontWeight: "bold" }}
                className="title_form"
              >
                Login
              </Typography>
              <Typography
                variant="span"
                component="div"
                className="desc"
                sx={{ mb: 4, pt: 1, fontSize: "15px" }}
              >
                Login to your account
              </Typography>
              <form autoComplete="off" onSubmit={handleSubmitForm}>
                <Stack gap={2}>
                  <FormControl variant="standard">
                    <Input
                      placeholder="UserName"
                      className="input"
                      type="text"
                      startAdornment={
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      }
                      onChange={handleChangeInput}
                      value={values.UserName}
                      name="UserName"
                    />
                    <p className="p-error">{formErrors.UserName}</p>
                  </FormControl>
                  <FormControl variant="standard">
                    <Input
                      placeholder="Password"
                      type={showPassword ? "text" : "password"}
                      className="input"
                      startAdornment={
                        <InputAdornment position="start">
                          <PasswordRounded />
                        </InputAdornment>
                      }
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            onMouseUp={handleMouseUpPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      onChange={handleChangeInput}
                      value={values.Password}
                      name="Password"
                    />
                    <p className="p-error">{formErrors.Password}</p>
                  </FormControl>

                  <Button
                    type="submit"
                    variant="contained"
                    className="btn_submit"
                    sx={{ mt: 3, mb: 1 }}
                  >
                    Submit
                  </Button>
                </Stack>
              </form>
            </CardContent>
          </Card>
        </Grid>
      </div>
    </div>
  );
}

export default Login;
